import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
// Libs

// Components
import Icon from '@/assets/icons'

// Constants
import { NOTIFICATION_ACTION } from '@/constants/liveRoom'

// Types

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export type NotificationItemType = {
  className?: string
  name: string
  context: string
  type?: string
  handleAnimationEnd?: any
  isLarge?: boolean
}

const NotificationItem = (props: NotificationItemType) => {
  const { className, name, context, type, handleAnimationEnd, isLarge } = props

  const isPurchaseNotification = type === NOTIFICATION_ACTION.PURCHASE
  const isUserInNotification = type === NOTIFICATION_ACTION.USER_IN

  const { t } = useTranslation()

  return (
    <>
      <div className={cx('item', className)} onAnimationEnd={handleAnimationEnd}>
        {/* 加入購物車 */}
        {isPurchaseNotification && (
          <div className={cx('item-content')}>
            <div className={cx('item-icon', 'item-icon--purchased')}>
              <Icon.Purchase />
            </div>
            <span className={cx('item-content-name', { isLargeText: isLarge })}>{name || '神秘用戶'}</span>
            <span className={cx('item-content-text', '--purchase', { isLargeText: isLarge })}>{`${t(
              'LiveRoom_Chat_Flag_Purchase',
            )} "${context}"`}</span>
          </div>
        )}

        {/* 用戶進入 */}
        {isUserInNotification && (
          <div className={cx('item-content')}>
            <div className={cx('item-icon')}>
              <Icon.Rocket />
            </div>
            <span className={cx('item-content-name', { isLargeText: isLarge })}>{name}</span>
            <span className={cx('item-content-text', '--user-in', { isLargeText: isLarge })}>{context}</span>
          </div>
        )}
      </div>
    </>
  )
}

export default NotificationItem
